import { render, staticRenderFns } from "./QueryPreviewTable.vue?vue&type=template&id=52e3ff2c&"
import script from "./QueryPreviewTable.vue?vue&type=script&lang=js&"
export * from "./QueryPreviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports